<template lang="html">
  <div class="placed-backg contact-page-" id="page-info-t1">
    <div class="bg-image" v-bind:style="{ backgroundImage: 'url(public/images/pages/contact/bg.jpg)' }"></div>

    <section class="container oversized-container content-section">
      <div class="row align-items-center justify-content-center" data-aos="fade-in" data-aos-duration="1000">
        <div class="col-lg-4 col-info">
          <h5 class="mb-2 page-title">¿Tienes alguna duda?</h5>
          <h5 class="subtitle-sm">Comunícate con nosotros</h5>
          <!-- <p>
            xxxxx
          </p> -->

          <br />
          <h5 class="f-w-600">Calle</h5>
          <p>
            <a>
              Av Chapultepec #1305a Pent House<br />
              Privadas del Pedregal<br />
              San Luis Potosi SLP, CP 78295<br />
              Ref: Edificio Open Corporativo
            </a>
          </p>

          <h5 class="mt-2 f-w-600">Teléfono</h5>
          <p>
            <a>
              800 611 0033
            </a><br />
            <a>
              *611 (Desde tu BlackFon)
            </a>

            <br />
            <!-- <br />
            <a>
              <strong class="f-w-600">Teléfono:</strong> (33) 2267 1167  <i class="fa-brands fa-whatsapp d-none d-lg-inline-block i-contact"></i>
            </a> -->
            <br />
            <a href="mailto:ventas@blackfon.mx">
              ventas@blackfon.mx <i class="fa-regular fa-envelope d-none d-lg-inline-block i-contact"></i>
            </a>
          </p>
        </div>

        <div class="col-lg-5 col-xl-4 col-info">
          <b-form @submit="onSubmit">
            <b-form-group>
              <b-form-input
                v-model="form.name"
                type="text"
                required
                placeholder="Nombre completo"
              ></b-form-input>
            </b-form-group>

            <b-form-group>
              <b-form-input
                v-model="form.email"
                type="email"
                required
                placeholder="Correo electrónico"
              ></b-form-input>
            </b-form-group>

            <b-form-group>
              <b-form-input
                v-model="form.phone"
                type="text"
                minlength="10"
                maxlength="10"
                required
                placeholder="Teléfono"
              ></b-form-input>
            </b-form-group>

            <b-form-group>
              <b-form-textarea
                v-model="form.msg"
                placeholder="Mensaje"
                required
                rows="5"
                max-rows="6"
              ></b-form-textarea>
            </b-form-group>

            <p class="text-center">
              <b-button type="submit" class="btn-send">ENVIAR MENSAJE</b-button>
            </p>
          </b-form>

        </div>
      </div>
    </section>

    <!-- <section class="container-fluid px-0 map-section">
      <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d119452.69716917786!2d-103.40545358012501!3d20.67377770932267!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8428b18cb52fd39b%3A0xd63d9302bf865750!2sGuadalajara%2C%20Jal.%2C%20M%C3%A9xico!5e0!3m2!1ses!2sca!4v1627506372341!5m2!1ses!2sca" allowfullscreen="" loading="lazy"></iframe>
    </section> -->
  </div>
</template>

<script>
export default {
  data(){
    return{
      form: {
        name: null,
        email: null,
        phone: null,
        msg: null
      },
      info: {
        contact:null,
      },
    }
  },

  methods: {
    makeToast(variant = null, msg, title) {
      this.$bvToast.toast(msg, {
        title: title,
        variant: variant,
        solid: true,
        toaster: 'b-toaster-top-right',
        appendToast: true
      })
    },

    getInfo: function(){
      axios.get(tools.url('/api/info')).then((response)=>{
        this.info = response.data;
      }).catch((error)=>{
        console.log(error);
      })
    },

    onSubmit(evt) {
      evt.preventDefault();
      //var data=tools.params(form, this.form);
      axios.post(tools.url("/api/contact"), this.form).then((response)=>{
          this.makeToast('success', response.data.response, 'Mensaje enviado');
          this.form = {
            name: null,
            email: null,
            msg: null,
            phone: null
          };
        }).catch( (error)=> {
        // console.log(error.response);
        let errors = error.response.data;
        // console.log(errors);
        this.makeToast('danger', error.response.data.name, 'Error');
        this.makeToast('danger', error.response.data.email, 'Error');
        this.makeToast('danger', error.response.data.phone, 'Error');
        this.makeToast('danger', error.response.data.msg, 'Error');
      });
    }
  },

  beforeMount(){
    // this.getInfo();
  }
}
</script>
